import React from "react";
import "./bankTable.css";

const BankTable = ({ page, banks, onEditBankClicked, onDeleteBankClicked }) => {
  const editBank = (bank) => {
    onEditBankClicked(bank);
  };

  const deleteBank = (bank) => {
    onDeleteBankClicked(bank);
  };

  return (
    <div className="bank-table-container">
      <table className="bank-table">
        <thead>
          <tr>
            <th width="100px">No</th>
            <th>Bank</th>
            <th width="150px">Actions</th>
          </tr>
        </thead>
        <tbody>
          {banks.length > 0 ? (
            banks.map((bank, index) => (
              <tr key={index}>
                <td>{(page - 1) * 10 + index + 1}</td>
                <td>{bank.bank_name}</td>
                <td>
                  <button
                    className="edit-doctor-specialist-button"
                    onClick={() => {
                      editBank(bank);
                    }}
                  >
                    Edit
                  </button>
                  <button
                    className="delete-doctor-specialist-button"
                    onClick={() => {
                      deleteBank(bank);
                    }}
                  >
                    Hapus
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3" style={{ textAlign: "center" }}>
                Data tidak tersedia
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default BankTable;
